/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useCallback, useEffect, useState} from 'react';
import dayjs from "dayjs";
import styles from './SubscriptionTab.module.scss';
import {User} from "../../../../types/User";
import userAPI from "../../../../api/userAPI";
import {Table, TableColumnsType} from "antd";
import {SubscriptionHistoryTable, SubscriptionTable} from "./SubscriptionTab.interface";

interface SubscriptionTabProps {
	selectedItem: User | undefined;
}

const SubscriptionTab = ({ selectedItem }: SubscriptionTabProps) => {
	const [subscriptions, setSubscriptions] = useState([]);
	const [subscriptionHistories, setSubscriptionHistories] = useState([]);

	const fetchData = useCallback(async () => {
		if (!selectedItem || !selectedItem.id) return;

		const [newSubscriptions, newSubscriptionHistories] = await Promise.all([
			userAPI.fetchSubscriptionAPI(selectedItem.id),
			userAPI.fetchSubscriptionHistoryAPI(selectedItem.id),
		]);
		setSubscriptions(newSubscriptions);
		setSubscriptionHistories(newSubscriptionHistories);
	}, [selectedItem]);

	useEffect(() => {
		fetchData();
	}, [selectedItem, fetchData]);

	const subscriptionColumns: TableColumnsType<SubscriptionTable> = [
		{
			title: 'create date',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 120,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),		},
		{
			title: '구글/애플',
			dataIndex: 'providerId',
			key: 'providerId',
			width: 80,
			align: 'center',
		},
		{
			title: 'original order id',
			dataIndex: 'originalOrderId',
			key: 'originalOrderId',
			width: 170,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums' }}>{value}</div>,
		},
		{
			title: 'order id',
			dataIndex: 'orderId',
			key: 'orderId',
			width: 170,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums' }}>{value}</div>,
		},
		{
			title: '상태',
			dataIndex: 'status',
			key: 'status',
			width: 30,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left' }}>{value}</div>,
		},
		{
			title: '시작일',
			dataIndex: 'startDate',
			key: 'startDate',
			width: 120,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),		},
		{
			title: '만료일',
			dataIndex: 'expireDate',
			key: 'expireDate',
			width: 120,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),		},
	];

	const subscriptionHistoryColumns: TableColumnsType<SubscriptionHistoryTable> = [
		{
			title: 'create date',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 140,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),
		},
		{
			title: '구글/애플',
			dataIndex: 'providerId',
			key: 'providerId',
			width: 60,
			align: 'center',
		},
		{
			title: 'original order id',
			dataIndex: 'originalOrderId',
			key: 'originalOrderId',
			width: 150,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums', fontSize: '11px' }}>{value}</div>,
		},
		{
			title: 'order id',
			dataIndex: 'orderId',
			key: 'orderId',
			width: 150,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums', fontSize: '10px' }}>{value}</div>,
		},
		{
			title: '이벤트 유형',
			dataIndex: 'eventType',
			key: 'eventType',
			width: 20,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontSize: '11px' }}>{value}</div>,
		},
		{
			title: '시작일',
			dataIndex: 'startDate',
			key: 'startDate',
			width: 140,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),
		},
		{
			title: '만료일',
			dataIndex: 'expireDate',
			key: 'expireDate',
			width: 140,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),
		},
	];

	return (
		<div className={styles.wrap}>
			{/* Subscription */}
			<Table
				title={() => <div>Subscription</div>}
				bordered
				columns={subscriptionColumns}
				dataSource={subscriptions}
				rowKey="id"
				size="small"
				scroll={{ x: 'max-content' }}
				pagination={false}
			/>

			<div style={{ marginTop: '20px' }} />

			{/* Subscription History */}
			<Table
				title={() => <div>Subscription History</div>}
				bordered
				columns={subscriptionHistoryColumns}
				dataSource={subscriptionHistories}
				rowKey="id"
				size="small"
				scroll={{ x: 'max-content' }}
				pagination={false}
			/>
		</div>
	);
};

export default SubscriptionTab;
